import React from 'react';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header public simplifié */}
      <nav className="bg-primary shadow-lg p-4">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-white font-medium">SAV MUP LLF</span>
          </div>
        </div>
      </nav>

      {/* Contenu principal */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer avec liens */}
      <Footer />
    </div>
  );
};

export default PublicLayout;
